import PropTypes from "prop-types";
import { useFormContext } from "react-hook-form";

import { convertStringToNumber } from "./../../../../helpers";

import TextInput from "../../../Form/TextInput";

const CashLotTaxInfo = ({ isLocked }) => {
  const {
    register,
    control,
    getValues,
    formState: { errors },
  } = useFormContext();

  return (
    <div className="form-section">
      <div className="form-section__header">
        <h3 className="form-section__title">
          If funding includes cash, enter total USD Cash Amount here
        </h3>
      </div>
      <div className="form-section__content two-columns">
        <TextInput
          register={register}
          errors={errors}
          control={control}
          name="cashAmount"
          label="Cash (USD) amount"
          options={{
            readOnly: isLocked,
            setValueAs: (v) => (v !== "" ? convertStringToNumber(v) : ""),
            masking: {
              numeral: true,
              numeralThousandsGroupStyle: "thousand",
              prefix: getValues("cashAmount") ? "$" : "",
              noImmediatePrefix: true,
            },
            required: false,
            showAsterisk: false,
          }}
        />
      </div>
    </div>
  );
};

CashLotTaxInfo.propTypes = {
  isLocked: PropTypes.bool,
};

export default CashLotTaxInfo;
